import { render, staticRenderFns } from "./ReleasePermissionsConfig.vue?vue&type=template&id=273f7a0a&scoped=true&"
import script from "./ReleasePermissionsConfig.vue?vue&type=script&lang=js&"
export * from "./ReleasePermissionsConfig.vue?vue&type=script&lang=js&"
import style0 from "./ReleasePermissionsConfig.vue?vue&type=style&index=0&id=273f7a0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273f7a0a",
  null
  
)

export default component.exports